export default "__VITE_ASSET__CTOQ9uaq__"